import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ApiService} from "../../../services/api.service";
import {
  endOfMonth,
  endOfWeek, endOfYear,
  format,
  formatDistance,
  formatRelative,
  startOfMonth,
  startOfWeek, startOfYear,
  subDays
} from 'date-fns'

import {ChartComponent} from "ng-apexcharts";
@Component({
  selector: 'app-activity-graph',
  templateUrl: './activity-graph.component.html',
  styleUrls: ['./activity-graph.component.scss']
})
export class ActivityGraphComponent implements OnInit, OnChanges {

  @ViewChild("chart", { static: false }) chart: ChartComponent;
  @Input() filterID: string | undefined;
  @Input() filterBy: 'brand' | 'campaign' | undefined;
  @Input() activityScope : string;

  public chartOptions: any;
  public today = new Date();

  public updateOptionsData = {
    "week": {
      xaxis: {
        labels: {
          format: "dd MMM"
        },
        min: startOfWeek(this.today).getTime(),
        max: endOfWeek(this.today).getTime()
      }
    },
    "month": {
      xaxis: {
        labels: {
          format: "dd MMM"
        },
        min: startOfMonth(this.today).getTime(),
        max: endOfMonth(this.today).getTime()
      }
    },
    "year": {
      xaxis: {
        labels: {
          format: "MMM"
        },
        min: startOfYear(this.today).getTime(),
        max: endOfYear(this.today).getTime()
      }
    },
    all: {
      xaxis: {
        min: undefined,
        max: undefined
      }
    }
  };
  data: any;

  constructor(private api: ApiService, public ref: ChangeDetectorRef) {
  }

  ngOnInit(): void {

    this.api.apiPost('core/reporting/donations/activity', {
      [this.filterBy + '_id'] : this.filterID,
      period: 'yearly'
    }).then((res)=>{
      this.data = res;
      this.initChart();
    }).catch((err)=>{
      console.log(err);
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateChart(changes)
  }

  updateChart(changes:SimpleChanges){
   if(changes.activityScope){
     if(this.chart){
       // @ts-ignore
       this.chart.updateOptions(this.updateOptionsData[this.activityScope], true, true, true)
     }
    }
  }

  initChart(){

    this.chartOptions = {
      colors: ['#ff7d32'],
      series: [
        {
          name: 'Amount Donated',
          data: this.data
        }
      ],
      chart: {
        fontFamily: 'Poppins, sans-serif',
        type: "area",
        height: '300',
        width: '100%',
        padding: 0,
        selection:{
          enabled: false
        },
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0
      },
      grid: {
        show: false
      },
      yaxis:{
        show: false
      },
      xaxis: {
        type: "datetime",
        labels:{
          style:{
            colors: '#212a4b',
            fontSize: '16px',
            fontWeight: 600
          },
          format: "dd MMM"
        },
        min: startOfMonth(this.today).getTime(),
        max: endOfMonth(this.today).getTime(),
        tickAmount: 6
      },
      tooltip: {
        theme: 'dark',
        x: {
          format: "dd MMM yyyy"
        },

      },
      stroke: {
        colors: ['#212a4b'],
        curve: 'smooth'
      },
      fill: {
        type: "gradient",
        colors: ['#ff7d32'],
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 100],

        }
      }
    };


    this.ref.detectChanges();
  }

}
